module.exports = __webpack_public_path__ + "static/media/BackMenu_HBT.16f3e1ec.svg";